import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { AuthService } from "src/app/services/auth.service";
import { InvoiceCashDeskService } from "src/app/services/invoice-cash-desk/invoice-cash-desk.service";
import { InvoiceIntegratedAdmissionCashDeskService } from "src/app/services/invoice-cash-desk/invoice-integrated-admission-cash-desk.service";

@Component({
  selector: "app-integrated-admission-invoice",
  templateUrl: "./integrated-admission-invoice.component.html",
  styleUrls: ["./integrated-admission-invoice.component.css"],
  providers: [
    {
      provide: InvoiceCashDeskService,
      useClass: InvoiceIntegratedAdmissionCashDeskService,
    },
  ],
})
export class IntegratedAdmissionInvoiceComponent implements OnInit {
  atention: string;
  returnUrl: string;
  noClose: boolean = false;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private authService: AuthService
  ) {}

  ngOnInit() {
    this.route.params.subscribe(async (params) => {
      this.atention = params["Atention"];
      this.returnUrl = params["return"];
    });

    this.noClose = !this.authService.CanCloseInvoiceIntegrated();
  }

  close() {
    this.router.navigate([
      "integrated-admission-operation",
      this.atention,
      this.returnUrl,
    ]);
  }
}
